<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
// TrashView of the admin console — template converted mechanically from design admin-taskcoolV1
// (design/tools/convert_admin_v1.py); values come from renderVals.ts.
import { s, hv } from '../tpl';
defineProps<{ g: any }>();
</script>

<template>
<div :style="s('display:flex; flex-direction:column; gap:14px; animation:apView 220ms ease-out;')">
  <div :style="s('display:flex; align-items:center; gap:10px; flex-wrap:wrap;')">
    <span :style="s('font-size:14px; color:#9c9da3; flex:1;')">موارد حذف‌شده {{ g.retentionLabel }} اینجا می‌مانند و بعد برای همیشه پاک می‌شوند.</span>
    <button @click="g.emptyTrash" :style="s('height:32px; padding:0 14px; border:none; border-radius:999px; background:oklch(0.68 0.14 25 / 0.18); color:oklch(0.78 0.12 25); font-family:inherit; font-size:13px; font-weight:700; cursor:pointer;')">خالی کردن سطل</button>
  </div>
  <div :style="s('border-radius:12px; background:#26272b;')">
    <template v-for="(xt, xt$i) in g.trashRows" :key="xt$i">
      <div :style="s(`display:flex; align-items:center; gap:14px; padding:${g.rowPad} 16px; border-bottom:1px solid #2a2b2f; font-size:14px; flex-wrap:wrap;`)">
        <span :style="s('flex:0 0 auto; font-size:11px; font-weight:700; padding:2px 9px; border-radius:999px; background:#34353a; color:#c9cacf;')">{{ xt.kind }}</span>
        <div :style="s('flex:1; min-width:200px;')"><div dir="auto" :style="s('font-weight:500;')">{{ xt.name }}</div><div :style="s('font-size:12px; color:#8a8b91;')">{{ xt.sub }}</div></div>
        <div :style="s('flex:0 0 140px; width:140px; display:flex; flex-direction:column; gap:4px;')">
          <span :style="s(`font-size:12px; color:${xt.leftColor};`)">{{ xt.left }}</span>
          <div :style="s('height:3px; border-radius:999px; background:#38393e;')"><div :style="s(`width:${xt.barW}; height:100%; border-radius:999px; background:${xt.leftColor};`)"></div></div>
        </div>
        <button @click="xt.onRestore" :style="s('height:28px; padding:0 12px; border:none; border-radius:7px; background:#34353a; color:#e7e7ea; font-family:inherit; font-size:12px; font-weight:700; cursor:pointer;')">بازیابی</button>
        <button @click="xt.onPurge" :style="s('height:28px; padding:0 10px; border:none; border-radius:7px; background:transparent; color:#9c9da3; font-family:inherit; font-size:12px; cursor:pointer;')" :class="[hv('color:oklch(0.78 0.12 25);')]">حذف دائمی</button>
      </div>
    </template>
    <template v-if="g.trashEmpty">
      <div :style="s('padding:40px; text-align:center; color:#8a8b91; font-size:14px;')">سطل زباله خالی است.</div>
    </template>
  </div>
</div>
</template>
